import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variant"];
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from '@miro-site/ui-design-system';
import { HeaderLogo } from './components/header-logo';
import { NavBarMetaMenu } from './components/meta-menu';
import { NavBar } from './components/nav-bar';
import { NavDrawerTrigger } from './components/nav-drawer';
import { NavDrawer } from './components/nav-drawer';
import { HeaderDataContextProvider } from './providers/header-data-context-provider';
import { HeaderStateContextProvider } from './providers/header-state-context-provider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Header = function Header(props) {
  var variant = props.variant,
      headerData = _objectWithoutProperties(props, _excluded);

  var isSimplifiedVariant = variant === 'simplified';

  var _useState = useState(isSimplifiedVariant),
      showSimplified = _useState[0],
      setShowSimplified = _useState[1];

  useEffect(function () {
    if (!isSimplifiedVariant) {
      return;
    }

    var handleScroll = function handleScroll() {
      if (window.scrollY === 0 && !showSimplified) {
        setShowSimplified(true);
        return;
      }

      if (window.scrollY !== 0 && showSimplified) {
        setShowSimplified(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showSimplified, isSimplifiedVariant]);
  return /*#__PURE__*/_jsx(HeaderDataContextProvider, {
    value: headerData,
    children: /*#__PURE__*/_jsxs(HeaderStateContextProvider, {
      children: [/*#__PURE__*/_jsx("div", {
        className: classNames({
          'bg-white border-bottom': !showSimplified
        }),
        style: {
          transition: 'background-color 100ms'
        },
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              className: "d-flex gap-100 py-200 justify-content-between",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "d-flex",
                children: [/*#__PURE__*/_jsx(NavDrawerTrigger, {}), /*#__PURE__*/_jsx(HeaderLogo, {}), /*#__PURE__*/_jsx(NavBar, {
                  className: classNames({
                    'opacity-0 pe-none': showSimplified
                  }),
                  style: {
                    transition: 'all 100ms'
                  }
                })]
              }), /*#__PURE__*/_jsx(NavBarMetaMenu, {})]
            })
          })
        })
      }), /*#__PURE__*/_jsx(NavDrawer, {})]
    })
  });
};
export default Header;